import { Users, UUID, Vote, VoteFull } from "../../types";
import { useLang } from "../services/lang";
import { UserVote } from "./User";

export type VoteUsersProps = {
    active: Vote | string,
    users: Users,
    votes: Record<UUID, VoteFull>,
    isMaybeOption: boolean,
    onChange: (option: Vote) => void,
};

export function VoteUsers({ active, users, votes, isMaybeOption, onChange }: VoteUsersProps) {
    const { dict } = useLang();

    const yes = Object.entries(votes).filter(([, v]) => v.vote === "yes").map(([user, vote]) => ({ ...vote, user: users[user] }));
    const maybe = Object.entries(votes).filter(([, v]) => v.vote === "maybe").map(([user, vote]) => ({ ...vote, user: users[user] }));
    const no = Object.entries(votes).filter(([, v]) => v.vote === "no").map(([user, vote]) => ({ ...vote, user: users[user] }));

    return <div className="who-votes-users">
        <div className={`who-vote-yes ${active === "yes" ? "active" : ""}`} onClick={() => onChange("yes")}>
            <div className="inner">
                {yes.length === 0 && <p className="info">{dict.whoNoVote}</p>}
                {yes.map((user, i) => <UserVote key={i} {...user} />)}
            </div>
        </div>
        {isMaybeOption && <div className={`who-vote-maybe ${active === "maybe" ? "active" : ""}`} onClick={() => onChange("maybe")}>
            <div className="inner">
                {maybe.length === 0 && <p className="info">{dict.whoNoVote}</p>}
                {maybe.map((user, i) => <UserVote key={i} {...user} />)}
            </div>
        </div>}
        <div className={`who-vote-no ${active === "no" ? "active" : ""}`} onClick={() => onChange("no")}>
            <div className="inner">
                {no.length === 0 && <p className="info">{dict.whoNoVote}</p>}
                {no.map((user, i) => <UserVote key={i} {...user} />)}
            </div>
        </div>
    </div>
}

export type VotesProps = {
    isMaybeOption: boolean,
    active?: Vote | "nothing",
    votes: {
        yes: number,
        maybe: number,
        no: number,
    },
    onClick?: (vote: Vote) => void,
}

export function Votes({ isMaybeOption, active, votes, onClick }: VotesProps) {
    return <>
        <V yes active={!active || active === "yes"} onClick={onClick ? () => onClick("yes") : undefined}>{votes.yes}</V>
        {isMaybeOption && <V maybe active={!active || active === "maybe"} onClick={onClick ? () => onClick("maybe") : undefined}>{votes.maybe}</V>}
        <V no active={!active || active === "no"} onClick={onClick ? () => onClick("no") : undefined}>{votes.no}</V>
    </>;
}


export type VProps = {
    yes?: boolean,
    no?: boolean,
    maybe?: boolean,
    active?: boolean,
    children?: React.ReactNode,
    onClick?: () => void,
}

export function V({ yes, no, maybe, active = true, children, onClick }: VProps) {
    let vote = "yes";
    if (no) vote = "no";
    if (maybe) vote = "maybe";

    return <div className={`v vote-${vote} ${active ? "active" : ""}`} onClick={e => {
        if (onClick) {
            e.stopPropagation();
            onClick();
        }
    }}>
        {typeof children !== "undefined" && <>{children}</>}
    </div>
}